import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import './Breadcrumb.scss'

@inject("ApplicationStore")
@observer
class Breadcrumb extends Component {
  render() {
    const { ApplicationStore } = this.props;

    if(ApplicationStore.minimalTemplate) return "";

    return (
      <ul className="Breadcrumb">
        {this.props.items.map(i => 
            <li className={`items ${i.active ? 'active' : ''}`} key={i.url}>
              <Link to={i.url}>
                {i.name}
              </Link>  
            </li>
        )}
      </ul>
    )
  }
}

export default Breadcrumb